import { Component, OnInit, Inject, AfterViewInit, OnDestroy } from '@angular/core';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import {TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Http } from '@angular/http';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { TopnavService } from '../header/topnav/topnav.service';
import { ToastrService } from '../../../node_modules/ngx-toastr';
import 'rxjs/add/operator/switchMap';
import { ISubscription } from 'rxjs/Subscription';
import { NavService } from '../header/nav/nav.service';
import { FormGroup, FormControl } from '../../../node_modules/@angular/forms';
import { PortalService } from '../services/portal.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { SharedService } from '../common/shared.service';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for highlightbox
 **/
@Component({
  selector: 'app-highlightbox',
  templateUrl: './highlightbox.component.html',
  styleUrls: ['./highlightbox.component.css']
})
export class HighlightboxComponent implements OnInit, AfterViewInit, OnDestroy {
    public notLogin: boolean = true; 
    infoMsg: any;
    highlightData: any;
    hotTopic: string;
    hotTopicContent: any[];
    hotTopicData: any[];
    penyertaan: any[];
    penyertaanContent: any[];
    penyertaanButton: any[];
    statuslabel: string;
    statusContent: string;
    hotTopicImg: string;
    peyertaanImg: string;
    permohonanImg: string;
    private subscription: ISubscription;
    private subscriptionLang: ISubscription;
    private subscriptionHotTopic: ISubscription;
    lang = 'en';
    languageId: any;
    filter= false;
    loading: boolean = false;
    result: any;
    updateForm: FormGroup

    noPermohonanCarian: FormControl
    sbgcolor: boolean;

    private highlightUrl: string = this.config.urlHighlights;
    private hottopicUrl: string = this.config.urlHotTopics;

    private subscriptionFontSize: ISubscription;

    public fontSize: any = {
      "sizeS" : "14px",
      "sizeM" : "19px",
      "sizeL" : "23px",
      "no_styles" : "0.9em"
    };

    public myflag: any;
    private isInitialized: boolean = false;

    constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService, public dialog: MatDialog, private router : Router,
      private toastr: ToastrService, private translate: TranslateService, private topnavservice: TopnavService, private portalService:PortalService, public navService: NavService, private http: Http, @Inject(APP_CONFIG) private config: AppConfig, private portalservice: PortalService){
        
        this.lang = translate.currentLang;
        this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
          const myLang = translate.currentLang;
          if (myLang === 'en') {
             this.lang = 'en';
             this.languageId = 1;
          }
          if (myLang === 'ms') {
            this.lang = 'ms';
            this.languageId = 2;
          }

          if(this.topnavservice.flagLang && this.isInitialized){
            this.subscriptionHotTopic = this.getHotTopic(this.lang);
            this.subscription = this.getData(this.lang);
            this.updateForm.reset();
            this.result = null;
          }
        });

        this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
          this.fontSize = data;
        });

        this.activatedRoute.queryParams.subscribe(params => {
          let lng = params['language'];
          if (lng && lng.toLowerCase() == 'my') {
            this.myflag = {language:"my"};
          } else {
            this.myflag = null;
          } 
        });
    }

    ngOnInit(){

      this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        window.scrollTo(0, 0);
      });

      if (!this.languageId) {
        if (localStorage.getItem('langID')) {
          this.languageId = localStorage.getItem('langID');
        } else { 
          this.languageId = 1;
        }
      }

      this.subscription = this.getData(this.lang);
      this.subscriptionHotTopic = this.getHotTopic(this.languageId);
      this.noPermohonanCarian = new FormControl()

      this.updateForm = new FormGroup({
        noPermohonanCarian: this.noPermohonanCarian
      });
    }

    ngAfterViewInit() {
      this.sharedService.loadFontSizeData();
    }

    ngOnDestroy() {
      this.subscriptionLang.unsubscribe();
      this.subscription.unsubscribe();
      this.subscriptionHotTopic.unsubscribe();
      this.subscriptionFontSize.unsubscribe();
    }



 
   getData(lang: string){
         return this.http.get(this.highlightUrl + '-' + lang + '.json')
           .map(res => res.json())
           .subscribe(eventData => {
                this.highlightData = eventData;
                this.hotTopic = eventData[0].label;
                this.hotTopicContent = eventData[0].content;
                this.hotTopicImg = eventData[0].url_image;
                this.peyertaanImg = eventData[1].url_image;
                this.permohonanImg = eventData[2].url_image;
                this.penyertaan = eventData[1].label;
                this.penyertaanContent = eventData[1].content;
                this.penyertaanButton = eventData[1].button;
                this.statuslabel = eventData[2].label;
                this.statusContent = eventData[2].content;

                setTimeout(()=>{
                  this.isInitialized = true;
                });
                
            },
            error => {
              this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
            });
    }

    getHotTopic(lang: string){

      return this.http.get(this.hottopicUrl+'?language='+this.languageId)
      .map(res => res.json().list)
      .subscribe(eventData => {
           this.hotTopicData = eventData;
           this.navService.loader = false;
       },
       error => {
        this.navService.loader = false;
         this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
       });
    }


    getModule(data){
      let a = data.split("/");
      return a[1];
    }

    getID(data){
      let a = data.split("/");
      return a[2];
    }
    checkRefNo(formvalues: any) {
      this.getUrl();
      let keyword = encodeURIComponent(formvalues.noPermohonanCarian); //formvalues.noPermohonanCarian.replace('#','%23');
      this.portalservice.getSubmissionStatus(keyword, this.languageId).subscribe(
        data => {
          this.result = data.statusDesc;
          if(data.statusCode == "ERROR") {
            this.sharedService.showError(' STATUS: '+this.result, '');
          } else {
            this.sharedService.showSuccess(' STATUS: '+this.result, '');
          }
          this.navService.loader = false;
      },
      error => {
        this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
        this.navService.loader = false;
      });
    }

    getUrl(){
      this.navService.loader = true;
    }

    getTheme(){
        return localStorage.getItem('themeColor');
    }

    openDialog() {
      this.dialog.open(OnlineServiceDialog, {
      });
    }

    openSurvey() {
      
    }

}

@Component({
  selector: 'online-service-popup',
  templateUrl: './online-service-popup.html',
})


export class OnlineServiceDialog implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OnlineServiceDialog>,
    private translate: TranslateService,
    private router: Router) {
    
    }

    ngOnInit() {
      this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        window.scrollTo(0, 0);
    });
    }

    onNoClick() {
      this.dialogRef.close();
    }

    goToRegister() {
      this.dialogRef.close();
      this.router.navigate(['/register']);
    }

    goToLogin() {
      // this.router.navigate(['./portal-protected/']);
      window.location.href = "../portal-protected/";
      this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/highlightbox/highlightbox.component.ts